import { TranslationKeys, PostProcessKeys } from 'translations';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ConfirmationModal from 'v2/common/ConfirmationModal/ConfirmationModal';
import styles from './hangOnASecondModal.module.scss';

export enum IamACustomerMessageEnum {
  withPurchasesButNotDatasetCustomer,
  customerOfDatasetButNotDataVendorCustomer,
  NotCustomerOfAnyDatasetButDataVendorCustomer,
  NotCustomerOfDataVendorButCustomerOfAnyDataset,
}

export function useIamACustomerMessage() {
  const { t } = useTranslation();

  return {
    withPurchasesButNotDatasetCustomer: {
      message: `This ${t(
        TranslationKeys.dataProduct_one
      )} isn't currently marked as purchased
    but you have a purchase record that indicates that it is.`,
      question: `Should we mark the ${t(
        TranslationKeys.dataProduct_one
      )} as purchased?`,
    },
    customerOfDatasetButNotDataVendorCustomer: {
      message: `You have marked one or more ${t(
        TranslationKeys.dataProduct_other,
        { postProcess: PostProcessKeys.TitleCase }
      )} as purchased for this ${t(TranslationKeys.dataProvider_one, {
        postProcess: PostProcessKeys.TitleCase,
      })}.`,
      question: `Would you like to mark the ${t(
        TranslationKeys.dataProvider_one,
        { postProcess: PostProcessKeys.TitleCase }
      )} itself as one you purchase from?`,
    },
    NotCustomerOfAnyDatasetButDataVendorCustomer: {
      message: `You have no ${t(TranslationKeys.dataProduct_other, {
        postProcess: PostProcessKeys.TitleCase,
      })} marked as purchased for this ${t(TranslationKeys.dataProvider_one, {
        postProcess: PostProcessKeys.TitleCase,
      })}
    but the ${t(TranslationKeys.dataProvider_one, {
      postProcess: PostProcessKeys.TitleCase,
    })} is still marked as one you purchase from.`,
      question: `Would you like to update the ${t(
        TranslationKeys.dataProvider_one,
        { postProcess: PostProcessKeys.TitleCase }
      )} itself to reflect that you do not purchase anything from them?`,
    },
    NotCustomerOfDataVendorButCustomerOfAnyDataset: {
      message: `You just said you weren't a customer of this ${t(
        TranslationKeys.dataProvider_one
      )}
    but you have ${t(
      TranslationKeys.dataProduct_other
    )} marked as being purchased.`,
      question: 'Should we mark them as no longer purchased?',
    },
  };
}

export interface HangOnASecondModalProps {
  onCancel: () => void;
  onOk: () => void;
  message: string;
  question: string;
  customTitle?: string;
}

const HangOnASecondModal = ({
  message,
  onCancel,
  onOk,
  question,
  customTitle = 'Hang on a second!',
}: HangOnASecondModalProps) => {
  return (
    <ConfirmationModal
      className={styles.viewModals}
      centered={true}
      animation={true}
      show={true}
      onCancel={onCancel}
      okBtnText="Yes"
      cancelBtnText="No"
      onOk={() => onOk()}
      title={customTitle}
    >
      <div>
        <p>
          {message} <strong>{question}</strong>
        </p>
      </div>
    </ConfirmationModal>
  );
};

export default HangOnASecondModal;
